import classnames from 'classnames';

export const classNames = classnames;
